export default "__VITE_ASSET__eddf6892__"